import {Dispatch} from "react";
import {IAction} from "src/context/IAction";
import {CONNECTION_ERROR} from "src/common/constants/constants";
import {fetchSections} from "src/service/ServiceMethods";
import {FETCH_SECTIONS, FETCH_SECTIONS_FAILURE, FETCH_SECTIONS_SUCCESS} from "src/context/actions/ActionTypes";

export function fetchSectionsAction(dispatch : Dispatch<IAction>) {
    fetchSections()
        .then((response) => {
            if (response.ok) {
                return response.json();
            }
            throw response.statusText;
        })
        .then((resolvedResponse) => {
            dispatch({
                type: FETCH_SECTIONS_SUCCESS,
                payload: resolvedResponse,
            });
        })
        .catch((err) => {
            dispatch({
                type: FETCH_SECTIONS_FAILURE,
                payload: !err ? CONNECTION_ERROR : err,
            });
        });
    dispatch({
        type: FETCH_SECTIONS
    });
}